import React, { useEffect, useState } from "react";
import "./TransactionHistory.css";
import noRecordsImg from "../../images/shapes/no-record-found 3.png";
import LoginHeaderA from "../header/LoginHeaderA";
import Footer from "../footer/FooterW";
import { API_URL } from "../../constant";

const TransactionHistoryR = () => {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchTransactions = async () => {
      setLoading(true);
      setError("");

      try {
        const token = localStorage.getItem("auth_token");

        if (!token) {
          throw new Error("User is not authenticated. No token found.");
        }

        console.log("🔐 Fetching transaction history...");


        const response = await fetch(`${API_URL}/api/agent/wallet`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        const contentType = response.headers.get("content-type");
        const isJson = contentType && contentType.includes("application/json");

        if (!response.ok) {
          const errorData = isJson
            ? await response.json()
            : await response.text();
          console.error("❌ API error response:", errorData);

          const message = isJson
            ? errorData.message || "Failed to fetch transactions"
            : `Error ${response.status}: ${response.statusText}`;
          throw new Error(message);
        }

        const result = await response.json();
        console.log("✅ API response:", result);
        
        // Extract transactions from the response
        const transactionsData = result.transactions || [];
        
        console.log("✅ Transactions fetched:", transactionsData);
        setTransactions(transactionsData);
      } catch (err) {
        console.error("❗ Error fetching transactions:", err.message);
        setError(
          err.message || "An error occurred while fetching transactions."
        );
      } finally {
        setLoading(false);
      }
    };

    fetchTransactions();
  }, []);

  // Format date to a more readable format
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    
    try {
      const options = { year: "numeric", month: "short", day: "numeric" };
      return new Date(dateString).toLocaleDateString(undefined, options);
    } catch (error) {
      console.error("Error formatting date:", error);
      return dateString;
    }
  };

  return (
    <>
      <LoginHeaderA />
      <div className="transaction-container">
        <div className="transaction-header">
          <h2 className="title">Transaction History</h2>
          <div className="transaction-count">
            {transactions.length}{" "}
            {transactions.length === 1 ? "Transaction" : "Transactions"}
          </div>
        </div>

        <div className="transaction-content">
          {loading ? (
            <div className="loading-container">
              <div className="loading-spinner"></div>
              <p>Loading transactions...</p>
            </div>
          ) : error ? (
            <div className="error-container">
              <div className="error-icon">⚠️</div>
              <p className="error-message">{error}</p>
              <button
                className="retry-button"
                onClick={() => window.location.reload()}
              >
                Try Again
              </button>
            </div>
          ) : transactions.length > 0 ? (
            <div className="table-container">
              <div className="table-header">
                <div className="cell date">Date</div>
                <div className="cell type">Type</div>
                <div className="cell description">Description</div>
                <div className="cell units">Amount</div>
              </div>
              <div className="table-body">
                {transactions.map((txn, idx) => (
                  <div className="table-row" key={idx}>
                    <div className="cell date" data-label="Date">
                      {formatDate(txn.date || txn.created_at)}
                    </div>
                    <div className="cell type" data-label="Type">
                      <span
                        className={`type-badge ${(txn.transaction_type || '').toLowerCase()}`}
                      >
                        {txn.transaction_type || 'N/A'}
                      </span>
                    </div>
                    <div className="cell description" data-label="Description">
                      {txn.description || 'No description'}
                    </div>

                    <div
                      className={`cell units ${
                        (txn.transaction_type || '').toLowerCase() === 'debit' || 
                        (txn.amount && String(txn.amount).startsWith("-"))
                          ? "negative"
                          : "positive"
                      }`}
                      data-label="Amount"
                    >
                      {(txn.transaction_type || '').toLowerCase() === 'debit' || 
                       (txn.amount && String(txn.amount).startsWith("-"))
                        ? "-" 
                        : "+"}
                      {Math.abs(txn.amount || 0)} TopCoins
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <div className="no-records">
              <img src={noRecordsImg} alt="No records" />
              <h3>No transactions yet</h3>
              <p>
                Please make a purchase using your QR code at partner shops to
                earn TopCoin.
              </p>
            </div>
          )}
        </div>

        <div className="back-link">
          <a href="/retail-agent/wallet">Back to Wallet &lt;&lt;</a>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default TransactionHistoryR;